export const EMPTY_USER_PERMISSIONS = {
  clientRoles: [],
  realmRoles: [],
  administrador: false,
  permissionToggles: {}
};

const ACCESS_DENIED_STATUS = [403, 404];
const GLOBAL_ERROR_DISPATCHED_KEY = '__globalErrorDispatched';

export const isAccessDeniedError = (error: unknown): boolean => {
  const status = (error as { response?: { status?: number } })?.response
    ?.status;

  return ACCESS_DENIED_STATUS.includes(Number(status));
};

export const markGlobalErrorAsDispatched = (error: unknown): void => {
  if (error && typeof error === 'object') {
    (error as Record<string, unknown>)[GLOBAL_ERROR_DISPATCHED_KEY] = true;
  }
};

export const dispatchGlobalError = (error: unknown): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (
    error &&
    typeof error === 'object' &&
    (error as Record<string, unknown>)[GLOBAL_ERROR_DISPATCHED_KEY]
  ) {
    return;
  }

  markGlobalErrorAsDispatched(error);
  window.dispatchEvent(new ErrorEvent('unhandledrejection', { error }));
};
